// extracted by mini-css-extract-plugin
export default {"clickable":"premios_clickable__HZcV3"};